import type {
    EngagementRingStoneRecommendationCardFragment,
    StoneRecommendationsNotFoundFragment,
} from '@/graphql/api'
import type { RingBuilderStoneTypes } from '@/domain/product/ring/ring-builder'

export function getEngagementRingStoneRecommendationCardTitle(
    content: EngagementRingStoneRecommendationCardFragment | undefined,
    data: RingBuilderStoneTypes | StoneRecommendationsNotFoundFragment
): string | undefined {
    if (data.__typename === 'NonSkuGemstone') {
        return content?.title.replace('{{color}}', data.color.translation.name)
    }

    return content?.title
}

export function getEngagementRingStoneRecommendationCardSubtitle(
    content: EngagementRingStoneRecommendationCardFragment | undefined,
    data: RingBuilderStoneTypes | StoneRecommendationsNotFoundFragment
): string | undefined {
    if (data.__typename === 'NonSkuGemstone') {
        return content?.description.replace(
            '{{color}}',
            data.color.translation.name.toLocaleLowerCase()
        )
    }

    return content?.description
}
